import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;
const Page = styled.div`
    font-size: 12px;
    text-transform: uppercase;
    color: #ccc;
    height: 30px;
    min-height: 30px;
    min-width: 30px;
    padding: 0 5px;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .4s ease 0s;
    
    &:hover {
        color: #fff;
        background-color: #777;
    }

    &.selected {
        background-color: #555;
    }

    &.selected:hover {
        background-color: #777;
        color: #fff;
    }
`;
const NoPage = styled.div`
    font-size: 12px;
    color: #ccc;
    height: 30px;
    min-height: 30px;
    padding: 0 5px;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default ({current, pages, onPageChange, ...props}) => {
    
    const pageItems = useMemo(() => {
        let items = [];
        const firstPage = Math.max(current-2, 1)
        const lastPage = Math.min(current+2, pages)
        
        for(let i=firstPage; i<=lastPage; i++) {
            items.push({pg:i, selected: i === current})
        }

        if (firstPage > 2) {
            items = [{pg:null}, ...items]
        }
        if (firstPage !== 1) {
            items = [{pg:1, selected: false}, ...items]
        }

        if (lastPage < pages-1) {
            items = [...items, {pg:null}]
        }
        if (lastPage !== pages) {
            items = [...items, {pg:pages, selected: false}]
        }


        return items;
    }, [current, pages]);

    const handlePageChange = (pg, e) => {
        if (onPageChange && typeof onPageChange === 'function') {
            onPageChange(pg, e);
        }
    }

    return <Row {...props}>
        {pageItems && pageItems.length > 1 ? 
            pageItems.map((page,i) => page.pg ? <Page 
                key = {i}
                className={page.selected ? 'selected' : ''}
                onClick={(e) => handlePageChange(page.pg, e)}
            >{page.pg}</Page> : <NoPage key = {i}>...</NoPage>) 
        : null}
    </Row>




}